import React from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/theme.js";

const config = require("data/siteConfig");

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function CareersPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>{config.siteName} - Home</title>
      </Helmet>

      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand={config.siteName}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/background.jpeg").default}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <h1 className={classes.parallaxTitle}>Error 404</h1>
              <h3 className={classes.title}>Page Not Found</h3>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <Footer whiteFont />
    </div>
  );
}
